// extracted by mini-css-extract-plugin
export default {"accordion-details":"AccordionDetails_accordion-details__hK-HE","accordion-details--animate":"AccordionDetails_accordion-details--animate__XcJx0"};